import React from 'react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export function GoogleLoginButton({ label = 'Continue with Google', className = '', testId = 'google-login-button' }) {
  const { loginWithGoogle } = useAuth();
  return (
    <Button
      type="button"
      onClick={loginWithGoogle}
      variant="outline"
      className={`h-11 w-full gap-2 border-white/20 bg-white text-neutral-900 hover:bg-neutral-100 hover:text-neutral-900 ${className}`}
      data-testid={testId}
    >
      <GoogleGlyph />
      <span className="font-semibold">{label}</span>
    </Button>
  );
}

function GoogleGlyph() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      width="18"
      height="18"
      focusable="false"
      className="shrink-0"
    >
      <path
        fill="#EA4335"
        d="M12 10.2v3.9h5.5c-.24 1.4-1.65 4.1-5.5 4.1-3.3 0-6-2.73-6-6.1S8.7 6 12 6c1.88 0 3.14.8 3.86 1.49l2.63-2.54C16.95 3.46 14.68 2.5 12 2.5 6.76 2.5 2.5 6.76 2.5 12S6.76 21.5 12 21.5c6.92 0 9.5-4.86 9.5-7.4 0-.5-.06-.9-.14-1.3H12z"
      />
      <path
        fill="#4285F4"
        d="M21.36 12.21c0-.5-.05-.98-.14-1.44H12v2.88h5.26c-.23 1.22-.92 2.26-1.96 2.96l3.17 2.46c1.85-1.7 2.89-4.2 2.89-6.86z"
      />
      <path
        fill="#FBBC05"
        d="M5.5 14.4a5.9 5.9 0 010-3.8l-3.26-2.52A9.5 9.5 0 002.5 12c0 1.52.37 2.96 1.03 4.22l2.97-1.82z"
      />
      <path
        fill="#34A853"
        d="M12 21.5c2.57 0 4.73-.85 6.3-2.3l-3.17-2.46c-.85.59-1.98.94-3.13.94-2.4 0-4.44-1.62-5.17-3.8L3.86 15.7A9.5 9.5 0 0012 21.5z"
      />
    </svg>
  );
}
